import CONFIG from './config';
import React, { Component } from 'react';
import Icon from './Icons';

class Footer extends Component {
	render() {
		return (
			<footer className='container'>
        <div className='container'>
          <Icon icon="spider"/>
        </div>
			</footer>
		)
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js